import { render, staticRenderFns } from "./NewPage.vue?vue&type=template&id=5590a1a6&scoped=true&"
import script from "./NewPage.vue?vue&type=script&lang=js&"
export * from "./NewPage.vue?vue&type=script&lang=js&"
import style0 from "./NewPage.vue?vue&type=style&index=0&id=5590a1a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5590a1a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
